import api from './api';

const d = (r) => r.data;
const MP = { headers: { 'Content-Type': 'multipart/form-data' } };
const B = '/api/clearance';
export const clearanceAPI = {
  meta: () => api.get(`${B}/meta`).then(d),
  settings: () => api.get(`${B}/settings`).then(d),
  saveSettings: (body) => api.put(`${B}/settings`, body).then(d),
  tracker: (params) => api.get(`${B}/tracker`, { params }).then(d),
  client: (cid) => api.get(`${B}/clients/${cid}`).then(d),
  syncOnboarding: (cid) => api.post(`${B}/clients/${cid}/sync-onboarding`).then(d),
  gateOverride: (cid, reason) => api.post(`${B}/clients/${cid}/gate-override`, { reason }).then(d),
  create: (body) => api.post(`${B}/cases`, body).then(d),
  update: (id, body) => api.put(`${B}/cases/${id}`, body).then(d),
  setStatus: (id, status, reason) => api.post(`${B}/cases/${id}/status`, { status, reason }).then(d),
  sendAuthority: (id) => api.post(`${B}/cases/${id}/authority/send`).then(d),
  refreshAuthority: (id) => api.post(`${B}/cases/${id}/authority/refresh`).then(d),
  overrideAuthority: (id, reason) => api.post(`${B}/cases/${id}/authority/override`, { reason }).then(d),
  requestLetter: (id) => api.post(`${B}/cases/${id}/request-letter`).then(d),
  send: (id, body) => api.post(`${B}/cases/${id}/send`, body).then(d),
  manualSend: (id, fd) => api.post(`${B}/cases/${id}/manual-send`, fd, MP).then(d),
  response: (id, fd) => api.post(`${B}/cases/${id}/responses`, fd, MP).then(d),
  review: (id, body) => api.put(`${B}/cases/${id}/review`, body).then(d),
  decide: (id, body) => api.post(`${B}/cases/${id}/decision`, body).then(d),
  startTransfer: (id) => api.post(`${B}/cases/${id}/records-transfer`).then(d),
  updateItem: (iid, body) => api.put(`${B}/records-items/${iid}`, body).then(d),
  itemDoc: (iid, fd) => api.post(`${B}/records-items/${iid}/document`, fd, MP).then(d),
  completeTransfer: (rid) => api.post(`${B}/records-transfer/${rid}/complete`).then(d),
  myEntities: () => api.get(`${B}/my/entities`).then(d),
  myAuthorities: () => api.get(`${B}/my/authorities`).then(d),
  mySign: (id) => api.post(`${B}/my/authorities/${id}/sign`).then(d),
  myRefresh: (id) => api.post(`${B}/my/authorities/${id}/refresh`).then(d),
};

export const PC_TONE = {
  not_required: 'bg-slate-100 text-slate-700', details_required: 'bg-amber-100 text-amber-800', authority_pending: 'bg-amber-100 text-amber-800',
  ready_to_send: 'bg-sky-100 text-sky-800', pending_approval: 'bg-sky-100 text-sky-800', sent: 'bg-indigo-100 text-indigo-800',
  follow_up_due: 'bg-orange-100 text-orange-800', response_received: 'bg-teal-100 text-teal-800', concerns_raised: 'bg-red-100 text-red-800',
  under_review: 'bg-violet-100 text-violet-800', cleared: 'bg-emerald-100 text-emerald-800', proceeding_risk: 'bg-emerald-50 text-emerald-900 border border-amber-300',
  declined: 'bg-red-200 text-red-900', closed: 'bg-muted text-muted-foreground',
};
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString('en-AU') : '—');
